import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ParentPaper } from '../../atoms/parent-paper';
import { SwitchBox } from '../../molecules/switch-box';
import { SliderBox } from '../../molecules/slider-box';
import { InputBox } from '../../molecules/input-box';

import { useSelector } from '../../store/utils';
import { ValueBox } from '../../molecules/value-box';

export const ThermostatSettingsService = () => {
  const thermostatCount = useSelector(({ variables }) =>
    Math.min(
      variables.THERMOSTAT_SETTINGS.length,
      variables.NUMBER_OF_THERMOSTATS
    )
  );

  return (
    <>
      <ParentPaper>
        <SwitchBox
          title={
            <FormattedMessage
              id="settings.thermostat.install"
              defaultMessage="Termostat aktivní"
            />
          }
          switchVariableId="THERMOSTAT_INSTALL"
          fullWidth
        />
        <SwitchBox
          title={
            <FormattedMessage
              id="settings.thermostat.hp-blocked"
              defaultMessage="Blokace tepelného čerpadla"
            />
          }
          visibility={{ variableId: 'HP_ENABLED' }}
          switchVariableId="THERMOSTAT_HP_BLOCKED"
          fullWidth
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="settings.thermostat.number-of-thermostat"
              defaultMessage="Počet termostatů"
            />
          }
          value={thermostatCount}
          visibility={{ variableId: 'THERMOSTAT_INSTALL' }}
        />
        <InputBox
          title={
            <FormattedMessage
              id="settings.thermostat.name1"
              defaultMessage="Pojmenování termostatu 1"
            />
          }
          visibility={{ variableId: 'THERMOSTAT_INSTALL' }}
          inputVariableId="THERMOSTAT_SETTINGS[0].name"
          label={
            <FormattedMessage
              id="settings.thermostat.name.label"
              defaultMessage="Název"
            />
          }
          fullWidth
        />

        {thermostatCount > 1 && (
          <InputBox
            title={
              <FormattedMessage
                id="settings.thermostat.name2"
                defaultMessage="Pojmenování termostatu 2"
              />
            }
            visibility={{ variableId: 'THERMOSTAT_INSTALL' }}
            inputVariableId="THERMOSTAT_SETTINGS[1].name"
            label={
              <FormattedMessage
                id="settings.thermostat.name.label"
                defaultMessage="Název"
              />
            }
            fullWidth
          />
        )}
        {thermostatCount > 2 && (
          <InputBox
            title={
              <FormattedMessage
                id="settings.thermostat.name3"
                defaultMessage="Pojmenování termostatu 3"
              />
            }
            visibility={{ variableId: 'THERMOSTAT_INSTALL' }}
            inputVariableId="THERMOSTAT_SETTINGS[2].name"
            label={
              <FormattedMessage
                id="settings.thermostat.name.label"
                defaultMessage="Název"
              />
            }
            fullWidth
          />
        )}
        {thermostatCount > 3 && (
          <InputBox
            title={
              <FormattedMessage
                id="settings.thermostat.name4"
                defaultMessage="Pojmenování termostatu 4"
              />
            }
            visibility={{ variableId: 'THERMOSTAT_INSTALL' }}
            inputVariableId="THERMOSTAT_SETTINGS[4].name"
            label={
              <FormattedMessage
                id="settings.thermostat.name.label"
                defaultMessage="Název"
              />
            }
            fullWidth
          />
        )}
        <SliderBox
          title={
            <FormattedMessage
              id="settings.thermostat.nominal"
              defaultMessage="Nominální příkon zdroje"
            />
          }
          variableId="THERMOSTAT_HP_CONSUMPTION"
          visibility={{
            variableIds: [
              'THERMOSTAT_INSTALL',
              { variableId: 'HP_ENABLED', reversed: true },
            ],
          }}
          opts={{
            style: 'unit',
            unit: 'kilowatt',
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }}
          step={0.1}
        />
        <SliderBox
          title={
            <FormattedMessage
              id="settings.thermostat.hysteresis"
              defaultMessage="Hystereze teploty"
            />
          }
          variableId={'THERMOSTAT_HYSTERESIS'}
          visibility={{
            variableId: 'THERMOSTAT_INSTALL',
          }}
          max={10}
          min={0}
          step={0.1}
          opts={{
            style: 'unit',
            unit: 'celsius',
            maximumFractionDigits: 1,
          }}
        />
      </ParentPaper>
    </>
  );
};
